import React, { useEffect, useState } from 'react'

import { Bar, BarChart, CartesianGrid, Cell, ReferenceLine, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

import "./AppBarChart.css"
import { Card, CardBody } from '@nextui-org/react';
import { useSelector } from 'react-redux';

function AppBarChart(props) {
  // state for hover styling on bar
  const [focusBar, setFocusBar] = useState(null);
  const userData = useSelector((state) => state.user.value);

  let displayData = props.data;

  // if no data is passed in, display no data


  // calculate a good barwidth from screensize
  const px = window.innerWidth;
  let barSize = px/15/displayData.length // /15 for scaling
  barSize = barSize > 50 ? 50 : barSize; // set a max at 50px


  // using custom text tick to 90 degree rotated text to tick line
  const CustomizedAxisTick = (props) => {
    const { x, y, stroke, payload } = props;

    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    let text = payload.value

    // Average -> Avg
    if (payload.value === "Average")
    {
      text = 'Avg'
    }
    // Month -> Abbreviate 
    else if (months.includes(payload.value))
    {
      text = payload.value.substring(0, 3)
    }
    // Name -> 1st letter of First Name, 1st + 2nd letters of Last Name
    else
    {
      const split = payload.value.split(' ')
      if (split.length > 1)
      {
        text = split[0] + " " + split[1].substring(0, 2) + '.'
      }
    }

      return (
        <g transform={`translate(${x},${y})`}>
          {/* 
          textAnchor = end : aligns everything to the top of the rotated text element 
          dx = 20 : push the text up towards the x-axis
          */}
          <text 
          x={0} 
          y={0} 
          dx = {20} 
          fontSize={'12px'} 
          fontWeight={'bold'} 
          textAnchor="end" 
          dominantBaseline="middle" 
          fill="var(--text-color)" 
          transform="rotate(-90)">
            {text}
          </text>
        </g>
      );
  }

  
  // tooltip that shows on hover of a chart
  const CustomTooltip = ({ active, payload, label }) => {
    // if the bar is active (hovered over) and there's a valid payload 
    if (active && payload && payload.length) {
      const difference = Math.round((payload[0].value - props.goal) * 10)/10

      // green if above or equal to goal, red if below
      let goalBackgroundColor = "green"
      if (difference < 0)
      {
        goalBackgroundColor = 'red'
      }

      const tooltipData = [
        {
          key : 'Real:',
          value : payload[0].value,
          backgroundColor : null
        },
        {
          key : 'Goal:',
          value : props.goal,
          backgroundColor : null
        },
        {
          key : 'Diff:',
          value : (difference<=0?"":"+") + difference,
          backgroundColor : goalBackgroundColor
        },
      ]

      return (
        <div className="app-bar-chart-custom-tooltip">
          <div className="app-bar-chart-custom-tooltip-header">{label}</div>
            {tooltipData.map((data) => 
            {
              return (
              <div key = {data.key} className="app-bar-chart-custom-tooltip-data">
                <div className="app-bar-chart-custom-tooltip-label">{data.key}</div>
                <div className="app-bar-chart-custom-tooltip-value" 
                     style = {{ backgroundColor: data.backgroundColor}}>
                      {data.value}
                </div>
              </div>
              )
            })}
        </div>
      );

    }
  
    return null;
  };

  // custom label displayed in reference line
  const CustomReferenceLineLabel = (props) => {

    const rectHeightVH = 2.5
    const rectWidthVW = 6.5


  // viewBox.x gets us to the baseline x, located to the far left of the line. 
  // scale by half of the viewbox width to center it horizontally, 
  let x = props.viewBox.x + props.viewBox.width/2;

  // boolean shift to shift x left by width of rectangle : NOT SCALABLE
  if (props.shift)
  {
   x = props.viewBox.x + props.viewBox.width/2 + (-window.innerWidth * rectWidthVW/100);
  }

  // viewBox.y gets us to the baseline y, located right below reference line. 
  // scale by half the height of rectangle to center in bar vertically
  // const y = props.viewBox.y - (window.innerHeight * 0.025)/2;
  const y = props.viewBox.y - (window.innerHeight * rectHeightVH/100)/2;

  return (
    <g id='custom-reference-line-label'>
    <rect
      id='custom-reference-line-label-rect'
      x={x}
      y={y}
      fill="white"
      width={rectWidthVW + 'vw'}
      height={rectHeightVH + 'vh'}
      rx="0.6vw" // border radius
      stroke = {'var(--primary-color)'}
      strokeWidth={1}
      />
    <text 
        id='custom-reference-line-label-text'
        x={x} 
        y={y} 
        fill="green"
        fontWeight={'bold'} 
        fontSize={'0.6vw'}
        dy={(window.innerHeight * rectHeightVH/100)/2} 
        dx={(window.innerWidth * rectWidthVW/100)/2}
        textAnchor='middle' // text centered horizontally in rectangle regardless of length
        dominantBaseline="middle" // text centered vertically
        >
      {props.value}
    </text>
  </g>
  )
  
  };

  if (displayData.length === 0)
  {
    return (
    <div className='app-bar-chart'>
      <div className='app-bar-chart-header'>
        {props.header}
      </div>
      <div className='app-bar-chart-no-data'>
        No Data Available
      </div>
    </div>)

    // old code for empty placeholder if no data is available
    // const empty = {}
      
    // empty[props.displayField] = 0
    
    // empty[props.xFieldName] = ""
    // displayData.push(empty)
  }


  return (
    <Card>
      <CardBody>
      <div className="text-lg font-bold text-center text-[#002e62] mb-4">{props.header}</div>
      <div className='relative'>
        <div className='absolute top-0 left-0 w-full'>
          <img src="/logo.png" alt="Logo" className='mx-auto h-[200px] opacity-20'/>
        </div>
        <ResponsiveContainer width="100%" height={200}>
          <BarChart
            data={props.data}
            margin={{
              right: window.innerWidth*0.005,
              // top: 5,
            }}
            onMouseLeave={() => setFocusBar(null)}
            onMouseMove={state => {
              if (state.isTooltipActive) {
                setFocusBar(state.activeTooltipIndex);
              } else {
                setFocusBar(null);
              }
            }}
          >
            {/* <CartesianGrid stroke="#dddddd" vertical = {false}/> */}
            <CartesianGrid strokeDasharray="3 3" vertical = {false} />
            <XAxis 
              dataKey={props.xFieldName} 
              stroke="var(--text-color)" 
              interval={0} // show every tick
              angle = {90} // rotating vertical
              tickMargin = {25} 
              height = {window.innerHeight*0.08} // 8vw
              tick={<CustomizedAxisTick/>}
            />
            <YAxis 
              stroke="var(--text-color)" 
              width={window.innerWidth*0.02} // 5vw
              fontSize={'0.7vw'}
            />
            <Tooltip content={<CustomTooltip />} cursor={{fill: '#e1e1e1'}} />

            {/* render each bar with map to allow for hover effect */}
            <Bar dataKey={props.displayField} barSize={barSize} radius={[5, 5, 0, 0]}>
              {props.data.map((entry, index) => (
                <Cell 
                  key={`cell-${index}`} 
                  // if the bar is focused, set fill to either green or red based on goal comparison. Otherwise, base color
                  fill={focusBar === index ? (entry[props.displayField] >= props.goal ? 'green' : '	red') : '#002e62'} />
              ))}
            </Bar>

            {/* horizontal line for team goal and label */}
            {props.goal && 
            <ReferenceLine 
            y={props.goal} 
            stroke="green" 
            strokeDasharray="5 2" 
            strokeWidth={1} 
            ifOverflow="extendDomain" 
            label = {<CustomReferenceLineLabel value={'TEAM GOAL: ' + props.goal} shift = {true}/>}/>}  
            {/* label = {<CustomReferenceLineLabel value={'TEAM GOAL: ' + props.goal} dx = {-window.innerWidth*0.07}/>}/>}   */}

            {/* horizontal line for income goal and label */}
            {props.incomeGoal && 
            (userData.role !== "manager") && 
            (userData.role !== "admin") &&
            <ReferenceLine 
            y={props.incomeGoal} 
            stroke="green" 
            strokeDasharray="5 2" 
            strokeWidth={1} 
            ifOverflow="extendDomain" 
            label = {<CustomReferenceLineLabel value={'INCOME GOAL: ' + props.incomeGoal}/>}/>
            }
          </BarChart>
        </ResponsiveContainer>
      </div>
    </CardBody>
    </Card>
  )
}

export default AppBarChart